/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'glyph/16/warning-yellow': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M11.314 0H4.686L0 4.686v6.628L4.686 16h6.628L16 11.314V4.686zM8 12a.945.945 0 01-1-1 .945.945 0 011-1 .945.945 0 011 1 .945.945 0 01-1 1zm1-3H7V4h2z" _fill="#969300"/>'
  }
})
